import React from 'react';

const Portfolio = () => {
  const projects = [
    {
      title: 'Modern Minimalist Villa',
      category: 'Residential',
      image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      title: 'Corporate Headquarters',
      category: 'Commercial',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      title: 'Luxury Apartment',
      category: 'Residential',
      image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      title: 'Boutique Hotel Lobby',
      category: 'Hospitality',
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
  ];

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12">
          <div>
            <p className="text-accent font-medium tracking-widest uppercase text-sm mb-2">Selected Works</p>
            <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold">Our Portfolio</h2>
          </div>
          <a href="#" className="hidden md:inline-block border-b-2 border-accent text-primary hover:text-accent transition-colors pb-1 uppercase tracking-wider text-sm font-medium mt-6 md:mt-0">
            View All Projects
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((project, index) => (
            <div key={index} className="group relative overflow-hidden rounded-sm cursor-pointer h-80 md:h-96">
              <img 
                src={project.image} 
                alt={project.title} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute bottom-0 left-0 p-8 translate-y-6 group-hover:translate-y-0 transition-transform duration-500 opacity-0 group-hover:opacity-100">
                <p className="text-accent text-sm font-medium tracking-wider uppercase mb-2">{project.category}</p>
                <h3 className="text-2xl font-serif text-white">{project.title}</h3>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-8 text-center md:hidden">
          <a href="#" className="inline-block border-b-2 border-accent text-primary hover:text-accent transition-colors pb-1 uppercase tracking-wider text-sm font-medium">
            View All Projects
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;